class ErrorHandler {

    isJson = (str) => {

        try {

            JSON.parse(str);

        } catch (e) {

            return false;
        }

        return true;
    }

    getErrorMessage = (err) => {

        if (!err) {
            
            return;
        }
        
        let message = '';

        if (err && err.response && err.response.text) {
            
            message = err.response.text;

            if (this.isJson(message)) {
             
                const json = JSON.parse(message);
      
                if (json.Message) {
                
                    return json.Message;
                }
            }
            else {
                
                return message;
            }
        }
    }
}

export default new ErrorHandler();


// WEBPACK FOOTER //
// ./src/services/web/erorrHandler.js